import { useEffect, useState } from "react";
import { Contact } from "../models/contact.ts"
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useContact = () => {
  const [options, setOptions] = useState<Contact[]>([]);
  const { handle } = useMessageHandler();

  useEffect(() => {
    handle(async () => {
      const response = await apiJson.get("/mechanics/contacts");
      setOptions(response.data);
    });
  }, []);

  return { options };
};